
import { getAllCredentialsApi } from '../../api/credentials/credentialApi';
import Types from '../types'
import { setGlobalLoader } from './commonAction';

export const getAllCredentials = (getAllDetails = false) => {
    return async function (dispatch) {
        dispatch(setGlobalLoader(true))
        const result = await getAllCredentialsApi(getAllDetails)
        dispatch({
            type: Types.ALL_CREDENTIALS,
            payload: result
        });
        dispatch(setGlobalLoader(false))
    }
}
